import React, { useState } from 'react';

/**
 * AssignmentForm component
 * Input form for submitting assignments to verify
 */
function AssignmentForm({ onSubmit, isConnected }) {
  const [assignmentText, setAssignmentText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate input
    if (!assignmentText.trim()) {
      alert('Please enter assignment text');
      return;
    }

    if (assignmentText.length < 50) {
      alert('Assignment text must be at least 50 characters');
      return;
    }

    setIsSubmitting(true);
    
    try {
      // Call parent handler with assignment text
      // For demo, we use mock payment proof
      await onSubmit(assignmentText, 'mock_payment_proof');
    } catch (error) {
      console.error('Submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClear = () => {
    setAssignmentText('');
  };

  // Example assignment for testing
  const loadExample = () => {
    setAssignmentText(
      "The Industrial Revolution was a period of major technological, socioeconomic, and cultural change in the late 18th and early 19th centuries. It began in Great Britain and rapidly spread throughout the world. This period saw a shift from agrarian and handicraft economies to ones dominated by industry and machine manufacturing. Key innovations included the steam engine, which revolutionized transportation and manufacturing, and the spinning jenny, which transformed textile production. The Industrial Revolution led to urbanization as people moved from rural areas to cities for factory work. While it brought economic growth and technological advancement, it also created challenges such as poor working conditions, child labor, and environmental pollution. The social and economic impacts of this period continue to influence modern society."
    );
  };

  return (
    <div className="assignment-form-section">
      <div className="form-card">
        <h2>📝 Submit Assignment for Verification</h2>
        <p className="form-description">
          Paste your AI-generated assignment below. Our system will check for logical consistency, 
          factual accuracy, and detect potential hallucinations.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="assignment">Assignment Text</label>
            <textarea
              id="assignment"
              className="form-textarea"
              value={assignmentText}
              onChange={(e) => setAssignmentText(e.target.value)}
              placeholder="Paste your assignment text here (minimum 50 characters)..."
              rows="12"
              disabled={!isConnected || isSubmitting}
            />
            <div className="char-count">
              {assignmentText.length} characters
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={loadExample}
              disabled={isSubmitting}
            >
              Load Example
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClear}
              disabled={isSubmitting || !assignmentText}
            >
              Clear
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!isConnected || isSubmitting || !assignmentText.trim()}
            >
              {isSubmitting ? 'Verifying...' : '🔍 Verify Assignment'}
            </button>
          </div>

          {!isConnected && (
            <p className="warning-text">
              ⚠️ Please connect your wallet to submit assignments
            </p>
          )}
        </form>
      </div>
    </div>
  );
}

export default AssignmentForm;
